/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsfieldactive2Inputs */

const en_ticketsfieldactive2 = /** @type {(inputs: Ticketsfieldactive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On sale`)
};

const de_ticketsfieldactive2 = /** @type {(inputs: Ticketsfieldactive2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Verkauf`)
};

/**
* | output |
* | --- |
* | "On sale" |
*
* @param {Ticketsfieldactive2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsfieldactive2 = /** @type {((inputs?: Ticketsfieldactive2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsfieldactive2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsfieldactive2(inputs)
	return de_ticketsfieldactive2(inputs)
});
export { ticketsfieldactive2 as "ticketsFieldActive" }